<div class="acknowledgement-page">
  <spinner *ngIf="!dataIsLoaded"></spinner>
  <div class="acknowledgement-page__center" *ngIf="dataIsLoaded">
    <div class="acknowledgement-page__center" *ngIf="ack; else error">
      <img src="/common/img/consent-image.svg" />
      <span class="acknowledgement-page__header">Thank you for giving your consent.</span>
      <span class="acknowledgement-page__info">
        We will submit your life insurance application automatically. You'll receive an email when your application is
        ready to be signed.
      </span>
    </div>
    <ng-template #error>
      <div class="acknowledgement-page__center">
        <span class="acknowledgement-page__header">Something went wrong.</span>
        <span class="acknowledgement-page__info">The consent email you received has expired.</span>
      </div>
    </ng-template>
    <a (click)="close()">Close this page</a>
  </div>
</div>
